module.exports = __webpack_public_path__ + "static/img/numbers_bg_tollfree.f2bb4968.png";